
let inject = [
    '$scope',
    'CartService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    'ngAuthSettings',
    'SessionService',
    '$timeout',
    '$mdToast',
    '$mdDialog',
    '$filter',
    'DetailZoneService',
    '$stateParams',
    'LoginService'
];

class LoadCartController {
    constructor($scope, CartService, $state, $rootScope, SharedService, $uibModal, ngAuthSettings, SessionService,
        $timeout, $mdToast, $mdDialog, $filter, DetailZoneService, $stateParams, LoginService) {
            
        this.$state = $state;
        this.ngAuthSettings = ngAuthSettings;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.SessionService = SessionService;
        this.CartService = CartService;
        this.SharedService = SharedService;
        this.zoneService = DetailZoneService;
        this.$stateParams = $stateParams;
        this.LoginService = LoginService;

    }

    $onInit() {
        
        let cartId = this.$stateParams.id || '';
        let userId = this.shCtrl.globals.currentUser && this.shCtrl.globals.currentUser.userId ? this.shCtrl.globals.currentUser.userId : '';
        
        this.CartService.getCartResumeData(cartId, userId).then(response => {
            
            //Si el dueño de la canasta es el usuario logueado: llevarlo a canasta
            if(response.hasOwnProperty('ownerUserId') && (response.ownerUserId === userId)) {
                this.$state.go('home.cart');
            }

            //Si el dueño de la canasta no es el usuario logueado: llevarlo  a loguin
            if(!response.hasOwnProperty('ownerUserId') || (response.ownerUserId != userId) || isNaN(parseInt(cartId, 10))) {
                this.LoginService.logout().then(response => {
                    this.shCtrl.globals = {};
                    this.shCtrl.cart = {};
                    this.SessionService.remove('globals');
                    this.SessionService.remove('cartId');
                    this.SessionService.remove('tunnelPayMethod'); 
                    this.SessionService.remove('tunnelCity');
                    this.$rootScope.reloadProyect = true;
                    this.$rootScope.reloadProyectState = 'home.login';
                    this.$rootScope.componentToRedirect = 'home.cart';
                    this.$state.reload(); 
                }); 
            } 
        });
    }
}

LoadCartController.$inject = inject;

export default LoadCartController;


/** WEBPACK FOOTER **
 ** ./www/components/load-cart/load-cart.controller.js
 **/